import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';

const Trigger = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
  padding: 0px;
  background: none;
  cursor: pointer;
`;

export const S = {
  ...UIElements,
  Trigger,
};
